import {
  IconCategoryParty,
  IconCategorySport,
  IconCategoryHealth,
  IconCategoryReligious,
  IconCategoryFashion,
  IconCategoryGamesGeek,
  IconCategoryKid,
  IconCategoryPride,
  IconCategoryFood,
  IconCategoryLearn,
  IconCategoryBusiness,
  IconCategoryOthers,
} from '@sympla/sympla-components/CategoryIcons';
import { IconLink } from '@sympla/sympla-components/ActionIcons';
import { IconAgenda } from '@sympla/sympla-components/SocialIcons';

export const categoryOptions = [
  {
    icon: <IconCategoryParty width={32} height={32} />,
    label: 'Festas e shows',
    value: '17-festas-e-shows',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryLearn width={32} height={32} />,
    label: 'Cursos e Workshops',
    value: '8-curso-e-workshops',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryBusiness width={32} height={32} />,
    label: 'Congressos e Palestras',
    value: '4-congressos-e-palestras',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategorySport width={32} height={32} />,
    label: 'Esportes',
    value: '2-esportes',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryFood width={32} height={32} />,
    label: 'Gastronomia',
    value: '1-gastronomia',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryOthers width={32} height={32} />,
    label: 'Arte, Cinema e Lazer',
    value: '10-arte-cinema-e-lazer',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryHealth width={32} height={32} />,
    label: 'Saúde e Bem-Estar',
    value: '9-saude-e-bem-estar',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryKid width={32} height={32} />,
    label: 'Infantil',
    value: '15-infantil',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryReligious width={32} height={32} />,
    label: 'Religião e Espiritualidade',
    value: '13-religiao-e-espiritualidade',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryGamesGeek width={32} height={32} />,
    label: 'Games e Geek',
    value: '12-games-e-geek',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryFashion width={32} height={32} />,
    label: 'Moda e Beleza',
    value: '11-moda-e-beleza',
    param: 'cl',
    description: '',
  },
  {
    icon: <IconCategoryPride width={32} height={32} />,
    label: 'Pride',
    value: '14-pride',
    param: 'cl',
    description: '',
  },
];

const priceOptions = [
  {
    param: 'p',
    label: 'Grátis',
    value: '0',
    description: '',
    icon: null,
  },
  {
    param: 'p',
    label: 'Pago',
    value: '1',
    description: '',
    icon: null,
  },
  {
    param: 'p',
    label: 'Qualquer preço',
    value: '',
    description: '',
    icon: null,
  },
];

const sortOptions = [
  {
    icon: <IconLink width={24} height={24} />,
    label: 'Relevância',
    description: 'Eventos em alta na sua Região',
    value: 'global-score-norm',
    param: '',
  },
  {
    icon: <IconAgenda width={24} height={24} />,
    label: 'Data',
    description: 'Eventos mais próximos de acontecer',
    value: 'start-date',
    param: '',
  },
];

const typeOptions = [
  {
    param: 'type',
    label: 'Presencial',
    value: 'normal',
    description: '',
    icon: null,
  },
  {
    param: 'type',
    label: 'Online',
    value: 'online',
    description: '',
    icon: null,
  },
  {
    param: 'type',
    label: 'Sympla Play',
    value: 'ondemand',
    description: '',
    icon: null,
  },
];

type OptionsType = {
  icon: JSX.Element | null;
  label: string;
  description: string;
  value: string;
  param: string;
};

type FilterParamsType = {
  collections: {
    name: string;
    options: OptionsType[];
    trackingLabel: string;
    title: string;
    label: string;
  };
  price: {
    name: string;
    options: OptionsType[];
    trackingLabel: string;
    title: string;
    label: string;
  };
  date: {
    name: string;
    options: OptionsType[];
    trackingLabel: string;
    title: string;
    label: string;
  };
  sort: {
    name: string;
    options: OptionsType[];
    trackingLabel: string;
    title: string;
  };
  type: {
    name: string;
    options: OptionsType[];
    trackingLabel: string;
    title: string;
    label: string;
  };
};

export const filterParams: FilterParamsType = {
  collections: {
    name: 'cl',
    options: categoryOptions,
    trackingLabel: '.jorney-discovery.step-page_search.component-filtroCategoria',
    title: 'Categorias',
    label: 'Categoria',
  },
  price: {
    name: 'p',
    options: priceOptions,
    trackingLabel: '.jorney-discovery.step-page_search.component-filtroPreco',
    title: 'Preço',
    label: 'Preço',
  },
  date: {
    name: 'd',
    options: [],
    trackingLabel: '.jorney-discovery.step-page_search.component-filtroData',
    title: 'Data',
    label: 'Data',
  },
  sort: {
    name: 'ordem',
    options: sortOptions,
    trackingLabel: '.jorney-discovery.step-page_search.component-filtroOrdenacao',
    title: 'Ordenar por',
  },
  type: {
    name: 'type',
    options: typeOptions,
    trackingLabel: '.jorney-discovery.step-page_search.component-filtroTipo',
    title: 'Tipo Evento',
    label: 'Tipo Evento',
  },
};
